import React from "react";
import { InputText as PrimeInputText } from "primereact/inputtext";

interface InputTextProps {
  style?: React.CSSProperties;
  className?: string;
  sectionClass?: string;
  id: string;
  type?: string;
  label: string;
  validation?: any;
  minlength?: any;
  maxlength?: any;
  modelValue: string;
  disabled?: boolean;
  placeholder?: string;
  IsLandingURL?: boolean;
  onlyNumber?: boolean;
  onUpdateModelValue: (value: string) => void;
  autofocus?: boolean;
}

const InputText: React.FC<InputTextProps> = ({
  style,
  className,
  sectionClass = "field",
  id,
  type = "text",
  label,
  validation,
  minlength,
  maxlength,
  modelValue,
  disabled = false,
  placeholder,
  IsLandingURL = false,
  onlyNumber = false,
  onUpdateModelValue,
  autofocus = false,
}) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onUpdateModelValue(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      (event.key < "0" || event.key > "9")
    ) {
      event.preventDefault();
    }
  };

  return (
    <div className={sectionClass}>
      <label htmlFor={id} className="form-label">
        {label}
      </label>
      <PrimeInputText
        id={id}
        type={type}
        value={modelValue}
        disabled={disabled}
        placeholder={placeholder}
        minLength={minlength}
        maxLength={maxlength}
        className={validation?.$error ? "p-invalid mt-1" : "mt-1"}
        aria-describedby={`${id}-help`}
        onChange={handleInputChange}
        autoFocus={autofocus}
        {...(onlyNumber ? { onKeyDown: handleKeyDown } : {})}
      />

      {validation?.$error &&
        validation.required &&
        validation.required.$invalid && (
          <span id={`${id}-help`} className="p-error text-left mt-2">
            {validation.required.$message}
          </span>
        )}
    </div>
  );
};

export default InputText;
